import { ModalFooter } from "@hostingbv/lib/src/components/layout/ModalProvider";
import { FC, useState } from "react";
import { config } from "../config";
import { useApiClient } from "@hostingbv/lib/src/api";
import { useRefresh } from "@hostingbv/lib/src/components/RefreshController";
import { Domain } from "@hostingbv/lib/src/api/partner/models/Domain";
import { Input } from "@hostingbv/lib/src/components/form/Input";
import { Paragraph } from "../../../lib/src/components/Paragraph";
import { Button, IconButton } from "../../../lib/src/components/form/Button";
import { faAdd, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useRealtimeDeployments } from "../components/deployments/RealtimeDeployments";

export const EditUseExternalNameserversModal: FC<{ domain: Domain, external: boolean }> = (props) => {
  const { partnerClient } = useApiClient(config)
  const refresh = useRefresh()
  const { awaitNextDeploymentFinished } = useRealtimeDeployments()!

  const [errors, setErrors] = useState<string[]>([])
  const [nameservers, setNameservers] = useState<string[]>(props.domain.externalDns ? props.domain.nameservers : ['', ''])

  const save = async () => {
    const deployment = await (props.external ? partnerClient.useExternalNameservers(props.domain.id, nameservers) : partnerClient.useInternalNameservers(props.domain.id))
    if (deployment.success) {
      await awaitNextDeploymentFinished(deployment.data.id)
      refresh()
    } else {
      setErrors(deployment.errors)
      throw "ERROR"
    }
  }

  return <>
    <form onSubmit={() => save()} className={""}>
      <Paragraph>{props.external ? "Do you really want to switch to using external nameservers?" : "You are about to use our nameservers, powered by Cloudflare."}</Paragraph>
      <Paragraph>{props.external ? "Make sure you make an export of your zone first, so have a backup just in case" : "If you have a zone/bind file, you can import this once these changes are applied."}</Paragraph>
      {props.external && <div className={"flex flex-col space-y-4"}>
        {nameservers.map((ns, i) => {
          return <div key={i} className={"flex items-end"}>
            <Input type={"text"} label={`Nameserver ${i + 1}`} value={ns} onChange={(e) => setNameservers((oldNss) => oldNss.map((oldNs, oldI) => oldI === i ? e : oldNs))} />
            <IconButton type={'danger'} size={'sm'} icon={faTimes} onClick={() => setNameservers(old => old.filter((v, fi) => fi !== i))} />
          </div>
        })}
        <Button size={'xs'} disabled={nameservers.length > 4} icon={faAdd} type={'secondary'} text={'Add nameserver'} onClick={() => setNameservers(old => [...old, ''])} />
      </div>}
      {errors.length > 0 && <div className={"bg-red-100 text-red-600 p-4 rounded-sm my-4"}>
        {errors.map((err, i) => <div key={i}>{err}</div>)}
      </div>}
      <ModalFooter text={props.external ? "Use external nameservers" : "Use our nameservers"} onSubmit={save} />
    </form>
  </>
}
